module.exports = __webpack_public_path__ + "img/teabig_yan.98a5b807.png";